export const REPLACE_ICONS_DATA = 'REPLACE_ICONS_DATA';
export type REPLACE_ICONS_DATA = typeof REPLACE_ICONS_DATA;
